export default __webpack_public_path__ + "static/media/1.90ed6390.jpg";